import { Appointment, APPOINTMENT_STATUS } from "@elixir/types";
import {
  cancelAppointmentReminders,
  updateAppointment,
} from "../../utils/bridges/methods";
import { logAndGetErrorResponse } from "../error";
import { ControllerReturnType } from "../types";
import {
  trackAppointmentActivity,
  AptActivityType,
} from "./appointment-activity";

export default async function markParked({
  appointment,
}: {
  appointment: Pick<Appointment, "aid" | "doctor_oid">;
}): Promise<ControllerReturnType> {
  try {
    const { aid } = appointment;
    const status = APPOINTMENT_STATUS.PARKED;

    await updateAppointment({
      data: {
        status,
      },
      aid,
    });

    cancelAppointmentReminders({ aid });
    trackAppointmentActivity({
      aid,
      activity: AptActivityType.VISIT_PARKED,
    });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
